import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../api/axiosConfig';

export default function SupportForm() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    message: '',
  });
  const [errors, setErrors] = useState<{ contact?: string }>({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({}); // reset lỗi khi người dùng sửa
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { name, contact, message } = formData;

    // ✅ Kiểm tra định dạng liên hệ
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^(?:\+?84|0)[1-9][0-9]{7,14}$/; // Hỗ trợ đầu 0 và +84

    let payload: any = {
      name,
      message,
      source: 'Form liên hệ',
    };

    if (emailRegex.test(contact)) {
      payload.email = contact;
    } else if (phoneRegex.test(contact)) {
      payload.phone = contact;
    } else {
      setErrors({ contact: 'Vui lòng nhập Email hoặc Số điện thoại hợp lệ.' });
      return;
    }

    try {
      await api.post('/contacts', payload);
      setSubmitted(true);
    } catch (error: any) {
      console.error('❌ Lỗi gửi form liên hệ:', error);
      alert(error.response?.data?.message || 'Gửi thất bại, vui lòng thử lại.');
    }
  };

  return (
    <div className="bg-[#DBF8C8] py-16 px-6 md:px-20">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
        {/* Ảnh minh họa */}
        <div className="flex justify-center">
          <img
            src="/images/tong-hop-san-pham.png"
            alt={t('support_form.product_alt') || 'Sản phẩm'}
            className="max-w-[90%] h-auto object-contain"
          />
        </div>

        {/* Form */}
        {!submitted ? (
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#365E1C] mb-4 relative inline-block">
              {t('support_form.title') || 'Liên hệ với chúng tôi'}
              <span className="absolute -bottom-1 left-0 w-full h-3 bg-[#ABDD87] -z-10"></span>
            </h2>
            <p className="text-gray-800 mb-6">
              {t('support_form.subtitle') || 'Vui lòng để lại thông tin để chúng tôi hỗ trợ bạn.'}
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Họ và tên */}
              <div>
                <label className="font-semibold">
                  {t('support_form.fields.name') || 'Họ và tên'}
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-600"
                />
              </div>

              {/* Thông tin liên hệ: Email hoặc SĐT */}
              <div>
                <label className="font-semibold">
                  {t('support_form.fields.contact') || 'Email hoặc Số điện thoại'}
                </label>
                <input
                  type="text"
                  name="contact"
                  required
                  value={formData.contact}
                  onChange={handleChange}
                  placeholder=""
                  className={`w-full p-2 border rounded ${
                    errors.contact ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:ring-2 focus:ring-green-600`}
                />
                {errors.contact && (
                  <p className="text-red-600 text-sm mt-1">{errors.contact}</p>
                )}
              </div>

              {/* Nội dung */}
              <div>
                <label className="font-semibold">
                  {t('support_form.fields.message') || 'Nội dung'}
                </label>
                <textarea
                  name="message"
                  rows={4}
                  required
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-600"
                ></textarea>
              </div>

              {/* Nút gửi */}
              <button
                type="submit"
                className="bg-[#658C4A] text-white px-6 py-2 font-semibold hover:bg-[#4d6e33] transition rounded"
              >
                {t('support_form.submit_button') || 'Gửi ngay'}
              </button>
            </form>
          </div>
        ) : (
          <div className="flex flex-col items-center text-center">
            <img src="/images/CTG-logo/Logo2.png" alt="CleanToGreen" className="w-64 mb-6" />
            <p className="text-2xl font-semibold mb-1">
              {t('support_form.success_title') || 'Gửi thành công!'}
            </p>
            <p className="text-lg">
              {t('support_form.success_subtitle') || 'Chúng tôi sẽ liên hệ với bạn sớm nhất.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
